import React, { useState } from 'react'
import Variables from './Variables';
import Chart from './Plot';
import styled from 'styled-components';
import { useRef } from 'react';


const Wrapper = styled.div`
    background-color: #3c3d3d;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: .6rem;
`


function Menu() {
  const [well_data, setWellData] = useState([]);
  return (
    <Wrapper>
      <Variables setWellData={setWellData}></Variables>
      <Chart well_data={well_data}></Chart>
    </Wrapper>
  )
}

export default Menu
